import m from "../../../../geodata/es2015/region/usa/gaHigh";
window.am4geodata_region_usa_gaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/gaHigh.js
// module id = null
// module chunks = 